import getHomeUrl from '../../../../../getHomeUrl';

function transform(_tagName, attribs) 
{
    const attributes = {
        tagName: 'meta',
        attribs: { ...attribs },
    };

    const protocol = 'http';

    if (
        attribs.name === 'twitter:image' ||
        attribs.property === 'og:image' ||
        attribs.property === 'og:url'
    ) 
    {
        if (!attribs.content.includes(protocol)) 
        {
            const url = getHomeUrl().replace(/\/+$/, '');
            attributes.attribs.content = `${url}${attribs.content}`;
        }
    }

    return attributes;
}

const allowedAttributes = ['name', 'content', 'property'];

export default {
    allowedAttributes,
    transform,
};
